import './PreviewCode.css';
import { useConversation } from '@/services/ConversationService';
import { useEffect, useState } from 'react';
import { buildPreviewLinks } from '@/services/PreviewLinks';

// NOTE: The react-qr-code package is fucked
// @ts-ignore
import { QRCode } from 'react-qr-code';
import {
  Column,
  ElevatedBorderStyle,
  Font,
  Row,
  ThinBorderStyle,
} from './DesignSystem';
import { FaRegCopy } from 'react-icons/fa6';

export type PreviewCodeProps = {
  embedInDevice?: boolean;
  style?: React.CSSProperties;
};

export function PreviewCode({ embedInDevice, style }: PreviewCodeProps) {
  const { state: conversationState, service: conversationService } =
    useConversation();
  const [sharedToPublic, setSharedToPublic] = useState(false);

  const conversationID =
    conversationState.type === 'conversation'
      ? conversationState.conversationID
      : conversationState.loading?.streaming?.conversationID;

  useEffect(() => {
    if (conversationState.type !== 'conversation') {
      return;
    }

    const conversationSharedToPublic = Boolean(
      conversationState.sharedToPublic,
    );
    if (conversationSharedToPublic !== sharedToPublic) {
      setSharedToPublic(conversationSharedToPublic);
    }
  }, [conversationState, sharedToPublic]);

  if (!conversationID) {
    return <></>;
  }

  if (conversationState.type !== 'conversation') {
    return <></>;
  }

  const { publicPreviewURL } = buildPreviewLinks({ conversationID });

  function PreviewLink() {
    const previewLinkHeight = 24;
    if (!sharedToPublic) {
      // Take up the height for the preview-link with an invisible element to
      // avoid layout shift
      return <div style={{ height: previewLinkHeight, padding: 4 }} />;
    }
    return (
      <Row
        className="preview-link"
        style={{
          height: previewLinkHeight,
          backgroundColor: '#E0F2FC',
          borderRadius: 12,
          padding: 4,
          alignItems: 'center',
        }}
        onClick={() => {
          navigator.clipboard.writeText(publicPreviewURL);
        }}
      >
        <div style={{ marginInlineStart: 4 }}>
          <FaRegCopy />
        </div>
        <div style={{ marginInlineStart: 4 }}>
          <Font kind="font-body">Preview Link</Font>
        </div>
      </Row>
    );
  }

  const borderStyle: React.CSSProperties =
    embedInDevice === true
      ? {
          alignItems: 'center',
        }
      : {
          ...ElevatedBorderStyle,
          borderColor: 'black',
          borderRadius: 12,
        };

  return (
    <Column
      style={{
        ...style,
        ...borderStyle,
        padding: 16,
        flexGrow: 0,
        backgroundColor: 'white',
        gap: 8,
        alignItems: 'center',
        display: 'flex',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          padding: '24px 0',
        }}
      >
        <Font kind="font-preview-header">Your app is ready to preview!</Font>
      </div>
      <div>
        <Font kind="font-preview-text">Scan to test on your phone:</Font>
      </div>
      <div style={{ ...ThinBorderStyle, padding: 20, width: 256 }}>
        <QRCode
          size={256}
          value={publicPreviewURL}
          style={{
            width: '100%',
            height: 'auto',
            maxWidth: 'clamp(150px, 25vw, 300px)',
          }}
        />
      </div>
      <form>
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
        >
          <div>
            <Font kind="font-preview-text">Share with your friends: </Font>
          </div>

          <input
            type="checkbox"
            style={{
              transform: 'scale(1.5)', // Makes it 50% larger
              marginRight: '10px', // Adds back some breathing room
              cursor: 'pointer',
            }}
            checked={sharedToPublic}
            onChange={(_) => {
              conversationService.sharePublicly();
            }}
          />
        </Row>
      </form>
      <PreviewLink />
    </Column>
  );
}
